






































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import { LoginModel } from "@/models/login/LoginModel";
import usuarioModule from "@/store/usuario/UsuarioModule";

@Component
export default class Login extends Vue {
  $refs!: {
    loginObserver: InstanceType<typeof ValidationObserver>;
  };

  login: LoginModel = {
    username: "",
    password: "",
  };

  //:to="{ name: 'AuthHome' }"
  efetuarLogin() {
    usuarioModule
      .efetuarLogin(this.login)
      .then(() => {
        this.$router.replace({ name: "HomePage" });
      })
      .catch((err) => {
        console.error(err);
        this.$refs.loginObserver.setErrors({
          Senha: "Usuário e/ou senha inválidos",
        });
      });
  }
}
